<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 mb-20 items-center">
    <div class="bg-white w-full rounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <router-link
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3"
            to="/expeditions"
          >
            <i class="material-icons mx-2">chevron_left</i>
          </router-link>
          <div v-if="!formData._id" class="text-2xl font-bold text-primary-500">
            {{ $t('new_expidition') }}
          </div>
          <div v-else class="text-2xl font-bold text-primary-500">
            {{ $t('edit_expidition') }}
          </div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6 pt-2 relative">
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <div>
            <!--  Select Colis -->
            <div class="px-6 mt-3">
              <div class="flex w-full space-x-2">
                <div
                  class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg"
                >
                  <div class="flex w-full">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-primary-400">person</i>
                    </span>

                    <div class="ml-5 w-full">
                      <div
                        class="text-base mt-1 font-semibold text-gray-600 pb-10"
                      >
                        {{ $t('package_information') }}
                      </div>
                      <div class="text-sm font-light text-gray-500"></div>
                      <div class="w-full space-y-4">
                        <div class="grid lg:grid-cols-2 gap-6">
                          <div
                            class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                          >
                            <div
                              class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                            >
                              <p>
                                <label
                                  for="customerFullName"
                                  class="bg-white text-gray-700 px-1"
                                >
                                  {{ $t('number_of_packages') }}
                                  <span :class="$colors.required"
                                    >*</span
                                  ></label
                                >
                              </p>
                            </div>
                            <p>
                              <input
                                id="customerFullName"
                                autocomplete="false"
                                tabindex="0"
                                type="number"
                                min="1"
                                v-model="formData.numberOfPackages"
                                class="py-2 text-xs px-2 outline-none block h-full w-full"
                              />
                            </p>
                          </div>

                          <div
                            class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                          >
                            <div
                              class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                            >
                              <p>
                                <label
                                  for="Weight"
                                  class="bg-white text-gray-700 px-1"
                                  >{{ $t('weight') }}
                                  <span :class="$colors.required"
                                    >*</span
                                  ></label
                                >
                              </p>
                            </div>
                            <div class="w-full rounded-md inline-flex">
                              <input
                                id="Weight"
                                autocomplete="false"
                                tabindex="0"
                                type="number"
                                min="1"
                                v-model="formData.weight"
                                class="py-2 text-xs px-2 outline-none block h-full w-full"
                              />
                              <div
                                class="rounded-md w-1/12 bg-gray-200 text-center"
                              >
                                {{ $t('kg') }}
                              </div>
                            </div>
                          </div>

                          <div
                            class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                          >
                            <div
                              class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                            >
                              <p>
                                <label
                                  for="customerFullName"
                                  class="bg-white text-gray-700 px-1"
                                >
                                  Pick up address
                                  <span :class="$colors.required"
                                    >*</span
                                  ></label
                                >
                              </p>
                            </div>
                            <p>
                              <input
                                v-model="formData.country"
                                class="py-2 text-xs px-2 outline-none block h-full w-full"
                              />
                            </p>
                          </div>

                          <div
                            class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                          >
                            <div
                              class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                            >
                              <p>
                                <label
                                  for="customerPhone"
                                  class="bg-white text-gray-700 px-1"
                                  >{{ $t('to') }}
                                  <span :class="$colors.required"
                                    >*</span
                                  ></label
                                >
                              </p>
                            </div>
                            <p>
                              <v-select @input="setSelectedToContry" v-model="formData.country_to" :options="warehouses" label="name">
                                <template slot="option" slot-scope="option">
                                  <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                                  {{ option.name }}
                                </template>
                              </v-select>
                            </p>
                          </div>

                          <div
                            class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                          >
                            <div
                              class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                            >
                              <p>
                                <label
                                  for="customerAddress"
                                  class="bg-white text-gray-700 px-1"
                                  >Pick up date
                                  <span :class="$colors.required"
                                    >*</span
                                  ></label
                                >
                              </p>
                            </div>
                            <p>
                              <input
                                id="dateexp"
                                autocomplete="false"
                                tabindex="0"
                                type="datetime-local"
                                v-model="formData.date"
                                class="py-2 text-xs px-2 outline-none block h-full w-full"
                              />
                            </p>
                          </div>
                          <div
                            class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                          >
                            <div
                              class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                            >
                              <p>
                                <label
                                  for="customerAddress"
                                  class="bg-white text-gray-700 px-1"
                                  >Close Time
                                  <span :class="$colors.required"
                                    >*</span
                                  ></label
                                >
                              </p>
                            </div>
                            <p>
                              <input
                                type="time"
                                pattern="[0-9]{2}:[0-9]{2}"
                                required
                                step="3600"
                                v-model="formData.closeTime"
                                class="py-2 text-xs px-2 outline-none block h-full w-full"
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Order Information -->
              </div>
              <!-- Status and seller Administration -->
              <div
                class="bg-white rounded-lg p-6"
                v-if="
                  currentUser &&
                    currentUser.type &&
                    currentUser.type != 'Seller'
                "
              >
                <div class="grid lg:grid-cols-2 gap-6">
                  <div
                    class="border seller-select h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="seller" class="bg-white text-gray-700 px-1"
                          >{{ $t('seller') }}
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <v-select
                        label="company"
                        @search="searchSellers($event, 'exp')"
                        v-model="formData.seller"
                        :options="sellers"
                      ></v-select>
                    </p>
                  </div>
                  <div
                    v-if="formData._id"
                    class="border seller-select h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="seller" class="bg-white text-gray-700 px-1"
                          >{{ $t('status') }}
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <select
                        name="status"
                        autocomplete="type"
                        disabled
                        v-model="formData.status"
                        class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                      >
                        <option class="bg-white" selected :value="null">
                          {{ $t('status') }}
                        </option>
                        <option
                          class="bg-white text-gray-600"
                          v-for="(value, index) in status"
                          :key="index"
                          :value="value"
                        >
                          {{ value }}
                        </option>
                      </select>
                    </p>
                  </div>
                  <div
                    class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="dateexpar"
                          class="bg-white text-gray-700 px-1"
                          >{{ $t('arrival_date') }}
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <input
                        id="dateexpar"
                        type="datetime-local"
                        v-model="formData.arrivalDate"
                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                      />
                    </p>
                  </div>
                  <div
                    class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label
                          for="customerPhone"
                          class="bg-white text-gray-700 px-1"
                          >{{ $t('expedition_fees') }}
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <input
                        id="fees"
                        autocomplete="false"
                        tabindex="0"
                        type="number"
                        min="0"
                        v-model="formData.fees"
                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                      />
                    </p>
                  </div>
                </div>
              </div>

              <!-- Product Table assigned to expedition -->
              <div class="flex w-full">
                <div class="flex space-x-2 w-full shadow-xs mt-1 rounded-lg">
                  <div
                    v-if="formData.status != 'received'"
                    class="flex w-full justify-between items-center h-auto p-6"
                  >
                    <div class="flex w-full">
                      <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-primary-500"
                          >local_mall</i
                        >
                      </span>
                      <div class="ml-3 w-full p-2 pb-8">
                        <div
                          class="w-full flex text-base font-semibold text-gray-600"
                        >
                          <p class="w-1/2">{{ $t('products') }}</p>
                          <div class="w-full">
                            <button
                              @click="OpenPopUp"
                              class="flex text-white mx-auto max-w-sm rounded-md text-center bg-primary-600 py-2 px-8 items-center focus:outline-none md:float-right"
                            >
                              {{ $t('select_product') }}
                            </button>
                          </div>
                        </div>

                        <div class="mt-4 overflow-x-auto">
                          <table
                            v-if="formData.details"
                            class="min-w-full table item leading-normal relative"
                          >
                            <loading
                              :active.sync="loading"
                              :is-full-page="fullPage"
                            ></loading>
                            <thead>
                              <tr>
                                <th
                                  class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                                >
                                  ID
                                </th>
                                <th
                                  class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                                >
                                  {{ $t('name') }}
                                </th>
                                <th
                                  class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                                >
                                  {{ $t('commodity_value') }}
                                  <sup v-if="wharhouse" class="text-black"
                                    >({{ wharhouse.currency }})</sup
                                  >
                                </th>

                                <th
                                  class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                                >
                                  {{ $t('quantity') }}
                                </th>

                                <th
                                  class="px-3 py-2 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                                >
                                  {{ $t('actions') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="(item, index) in formData.details"
                              :key="index"
                            >
                              <tr>
                                <td
                                  class="px-3 py-2 whitespace-no-wrap border-b border-gray-200"
                                >
                                  <div
                                    class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                                  >
                                    <b>{{ item.product.id }}</b>
                                  </div>
                                </td>
                                <td
                                  class="px-3 py-2 whitespace-no-wrap border-b border-gray-200"
                                >
                                  <div
                                    class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                                  >
                                    {{ item.product.name }}
                                  </div>
                                </td>

                                <td
                                  class="px-3 py-2 whitespace-no-wrap border-b border-gray-200"
                                >
                                  <div
                                    class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                                  >
                                    <input
                                      type="number"
                                      v-model="item.merchandise_value"
                                      min="0"
                                      class="px-2 py-2 border focus:ring-gray-500 focus:border-gray-900 sm:text-sm border-gray-600 rounded-md focus:outline-none text-gray-900"
                                    />
                                  </div>
                                </td>

                                <td
                                  class="px-3 py-2 whitespace-no-wrap border-b border-gray-200"
                                >
                                  <div class="flex space-x-6 justify-center">
                                    <button v-if="!item.variantes || (item.variantes && item.variantes.length === 0)"
                                      :class="$colors.textPrimary"
                                      class="bg-primary-600 rounded-md w-6 h-6 flex items-center focus:outline-none"
                                      @click="addQuantity(index)"
                                    >
                                      <span
                                        class="font-bold text-2xl text-white"
                                      >
                                        <i class="material-icons mt-2">add</i>
                                      </span>
                                    </button>

                                    <span
                                      :class="$colors.textPrimary"
                                      class="text-gray-700 text-sm h-6 flex items-center focus:outline-none"
                                    >
                                      <input
                                        class="focus:outline-none w-12 text-center"
                                        type="text"
                                        v-model="item.quantity.sent"
                                      />
                                    </span>

                                    <button v-if="!item.variantes || (item.variantes && item.variantes.length === 0)"
                                      :class="$colors.textPrimary"
                                      @click="removeQuantity(index)"
                                      class="bg-primary-600 rounded-md w-6 h-6 text-white flex items-center focus:outline-none"
                                    >
                                      <span
                                        class="font-bold text-2xl text-white mt-1"
                                      >
                                        <i class="material-icons">remove</i>
                                      </span>
                                    </button>
                                  </div>
                                  <template v-if="item.variantes && item.variantes.length>0">
                                      <h4 class="other-fees mt-2 variantes">Variantes</h4>
                                      <table class="table invoice-table  invoice-table-edit variantes-table w-full">
                                          <thead class="thead">
                                              <tr>
                                                <th class="px-2 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                                  Nom variante
                                                </th>
                                                <th class="px-2 py-1 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                                  <div class="w-full flex items-center justify-between">
                                                    <span>Quantity</span>
                                                    <i class="material-icons p-1 border-2 border-solid border-green-500 text-green-600 rounded-full cursor-pointer hover:bg-green-500 hover:text-white" style="font-size: 16px;" @click="openVariantModal(item._id)">edit</i>
                                                  </div>
                                                </th>
                                              </tr>
                                          </thead>
                                          <tbody class="invoice-items">
                                              <tr class="item-row item-row-1 with-tax" v-for="(variante, inddd) in item.variantes" :key="inddd">
                                                  <td data-label="Item #1" class="item-row-summary"><span class="item-row-name border border-gray-600"><div class="item-suggest"><div role="combobox" aria-haspopup="listbox" aria-owns="react-autowhatever-1" aria-expanded="false" class="react-autosuggest__container"><input type="text" disabled v-model="variante.name" autocomplete="off" aria-autocomplete="list" aria-controls="react-autowhatever-1" class="py-2 text-xs px-2 outline-none block h-full w-full" id="invoice-item-code" placeholder="Nom variante" value=""><div id="react-autowhatever-1" role="listbox" class="react-autosuggest__suggestions-container"></div></div></div></span></td>
                                                  <td data-label="Quantity" class="item-row-quantity">
                                                      <div class="w-full rounded-md inline-flex border border-gray-600">
                                                          <input type="number" v-model="variante.quantity.sent" @keypress="isNumber"  min="0" class="ml-2 w-full focus:outline-none rounded-md bg-white text-gray-700 focus:text-gray-600 p-1">
                                                      </div>
                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </template>
                                  <div
                                    class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                                  ></div>
                                </td>

                                <td
                                  class="py-4 whitespace-no-wrap border-b border-gray-200"
                                >
                                  <div class="flex justify-center">
                                    <button
                                      @click="removeProduct(item, index)"
                                      :class="$colors.actionTable"
                                      class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1"
                                    >
                                      <i class="material-icons mx-1">delete</i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Product Order -->
                  <div
                    v-if="formData._id && formData.status == 'received'"
                    class="flex w-full justify-between items-center h-auto p-6"
                  >
                    <div class="flex w-full mt-1">
                      <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-primary-400"
                          >local_mall</i
                        >
                      </span>
                      <div class="ml-5 w-full pb-4">
                        <div
                          class="text-base mt-1 font-semibold text-gray-600 pb-10"
                        >
                          {{ $t('expedition_products') }}
                        </div>
                        <div class="w-full space-y-4">
                          <div class="w-full">
                            <table class="min-w-full w-full">
                              <thead class="text-white">
                                <tr
                                  class="bg-primary-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0"
                                >
                                  <th class="p-2 justify-center">
                                    {{ $t('image') }}
                                  </th>
                                  <th class="p-2 justify-center">
                                    {{ $t('name') }}
                                  </th>
                                  <th class="p-2 justify-center">
                                    {{ $t('quantity_sent') }}
                                  </th>
                                  <th colspan="2" class="p-2 justify-center">
                                    {{ $t('quantity_received') }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="flex-1 sm:flex-none">
                                <tr
                                  v-for="it in formData.details"
                                  :key="it._id"
                                  class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0"
                                >
                                  <td
                                    class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2"
                                  >
                                    <div>
                                      <img
                                        :alt="it.product.name"
                                        :src="
                                          it.product.picture ||
                                            'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                        "
                                        class="h-16 w-16 rounded-md mx-auto"
                                      />
                                    </div>
                                  </td>
                                  <td
                                    class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"
                                  >
                                    <b>{{ it.product.name }}</b>
                                  </td>
                                  <td
                                    class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"
                                  >
                                    <input
                                      id="sent"
                                      :disabled="CheckExpeditionRecived"
                                      type="number"
                                      min="0"
                                      v-model="it.quantity.sent"
                                      class="py-2 border-4 border-light-orange-500 border-opacity-100 text-xs px-2 outline-none block h-full w-full"
                                    />
                                  </td>
                                  <td
                                    class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"
                                  >
                                    <table class="min-w-full">
                                      <thead>
                                        <tr>
                                          <th
                                            class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                          >
                                            Ok/Good
                                          </th>
                                          <th
                                            class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                          >
                                            Defective
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody class="bg-white">
                                        <tr>
                                          <td
                                            class="px-6 py-4 border whitespace-no-wrap"
                                          >
                                            <div class="flex items-center">
                                              <input
                                                id="Received"
                                                :disabled="
                                                  CheckExpeditionRecived
                                                "
                                                type="number"
                                                min="0"
                                                :max="it.quantity.sent"
                                                v-model="it.quantity.received"
                                                class="py-2 border-4 border-light-orange-500 border-opacity-100 text-xs px-2 outline-none block h-full w-full"
                                              />
                                            </div>
                                          </td>
                                          <td
                                            class="px-6 py-4 border whitespace-no-wrap"
                                          >
                                            <div class="flex items-center">
                                              <input
                                                id="Defective"
                                                :disabled="
                                                  CheckExpeditionRecived
                                                "
                                                type="number"
                                                min="0"
                                                :max="it.quantity.sent"
                                                v-model="it.quantity.defective"
                                                class="py-2 border-4 border-light-orange-500 border-opacity-100 text-xs px-2 outline-none block h-full w-full"
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- -->
            </div>
            <!-- button save -->
            <div class="w-full">
              <div class="pt-3 flex btn-bottom-toolbar justify-end">
                <button
                  :disabled="loading"
                  class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
                  @click="save"
                >
                  {{ $t('save') }}
                </button>
              </div>
            </div>
            <!--end button save -->

            
            <!-- Pop up Affectation products to Order -->
            <vue-modal-2
              name="Modal_products"
              :headerOptions="{ title: $t('add_products') }"
              :noFooter="true"
              modalSize="lg"
              @on-close="closePopUp"
            >
              <div class="flex p-5 pt-0 pb-1 flex-col w-full h-auto mb-13">
                <!-- Header -->
                <div class="flex w-full h-auto justify-center items-center">
                  <div
                    class="flex mb-3 w-full h-auto py-2 justify-center items-center text-2xl font-bold"
                  >
                    <span
                      class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex"
                    >
                      <input
                        type="search"
                        name="search"
                        v-model="searchText"
                        :placeholder="$t('search')"
                        class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none"
                      />
                      <i
                        class="material-icons text-primary-400 m-2 mr-5 text-lg w-4 h-4"
                        >search</i
                      >
                    </span>
                  </div>
                </div>
                <div>
                  <div v-if="products.length <= 0" class="py-2">
                    <span
                      class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base"
                    >
                      <p
                        class="font-semibold flex text-primary-500 whitespace-no-wrap"
                      >
                        <span class="">{{ $t('no_products_found') }}</span>
                      </p>
                    </span>
                  </div>
                  <div
                    v-for="(item, index) in resultSearchUsers"
                    :key="index"
                    :value="item._id"
                    class="flex space-x-5 items-center justify-between h-auto py-1 px-5 rounded border border-gray-300 mb-2"
                  >
                    <span>
                      <input
                        type="checkbox"
                        class="form-checkbox inline-block text-primary-500 border-orange-500"
                        @change="addProductsToTemp(item, index)"
                        v-model="item.check"
                      />

                      <img
                        :alt="item.name"
                        :src="
                          item.picture ||
                            'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                        "
                        class="inline-block h-16 mx-4 rounded-md"
                      />
                      <div class="inline-block">
                        <h3 class="text-gray-80">{{ item.name }}</h3>
                        <p class="text-gray-600 text-xs">
                          {{ exceptDes(item.description) }}
                        </p>
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <div class="modal-footer px-5 border0-t text-right">
                <button
                  @click="closePopUp"
                  class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
                >
                  {{ $t('cancel') }}
                </button>
                <button
                  @click="ConfirmOperation"
                  class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-600 py-2 px-8 items-center focus:outline-none md:float-right"
                >
                  {{ $t('confirm') }}
                </button>
              </div>
            </vue-modal-2>
            <!-- End Pop up Affectation products to Order -->

            <!--Modal set service seller Shipping -->
            <vue-modal-2
              name="ModalChangeSetSettingsSeller"
              :headerOptions="{
                title: expeditionData.setting.exist
                  ? `Définir les services pour le nouveau warehouse de ce seller`
                  : 'Définir le warehouse pour chaque produit',
              }"
              :noFooter="true"
              modalSize="lg"
              @on-close="$vm2.close('ModalChangeSetSettingsSeller')"
            >
              <loading
                :active.sync="expeditionData.loading"
                :is-full-page="fullPage"
              ></loading>
              <div class="bg-white rounded-lg">
                <div class="relative">
                  <div class="rounded-lg flex">
                    <div class="w-full p-4">
                      <div
                        class="change-status border hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1"
                      >
                        <div
                          class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                        >
                          <p>
                            <label
                              for="settings"
                              class="bg-white text-gray-700 px-1"
                              >Country (warhousing)</label
                            >
                          </p>
                        </div>
                        <p>
                          <input
                            v-if="expeditionData.country"
                            type="text"
                            disabled
                            v-model="expeditionData.country"
                            class="py-2 text-xs px-2 outline-none block h-full w-full"
                          />
                        </p>
                      </div>
                      <section
                        class="warehouse"
                        v-if="expeditionData.warhouseParent.exist"
                      >
                        <div class="flex mt-10 mb-5 items-center text-center">
                          <hr
                            class="border-gray-300 border-1 w-full rounded-md"
                          />
                          <label
                            class="block font-medium text-sm cursor-pointer text-primary-500 w-full"
                            ><span
                              class="font-medium text-base text-primary-800 dark:text-primary-200"
                              >Choisir warehouse</span
                            >
                          </label>
                          <hr
                            class="border-gray-300 border-1 w-full rounded-md"
                          />
                        </div>
                        <div class="bg-ww">
                          <h2 class="text-sm font-bold truncate mb-5">
                            Définir le warehouse pour chaque produit (<img
                              v-if="wharhouse"
                              :src="wharhouse.flag"
                              class="h-4 w-5 blob inline-block"
                              :alt="wharhouse.country"
                            />)
                          </h2>
                          <div
                            v-for="(item, index) in expeditionData.data.details"
                            :key="index"
                            :value="item._id"
                            class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-600 mb-2"
                          >
                            <div>
                              <img
                                :alt="item.product.name"
                                :src="
                                  item.product.picture ||
                                    'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                "
                                class="h-16 w-16 rounded-md mx-auto"
                              />
                            </div>
                            <div class="col-span-2 w-full">
                              <h3 class="text-gray-80">
                                {{ item.product.name }}
                              </h3>
                              <p>
                                <v-select
                                  v-model="item.warehouseParent"
                                  :options="checkWarehousingParent"
                                  placeholder="Select warehouse"
                                  label="name"
                                  class="border border-gray-600"
                                >
                                  <template slot="option" slot-scope="option">
                                    {{ option.name }}
                                    <span v-if="option.is_primary"
                                      >(Principal)</span
                                    >
                                  </template>
                                </v-select>
                              </p>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!--services -->
                      <section v-if="expeditionData.setting.exist">
                        <div class="flex mt-10 mb-5 items-center text-center">
                          <hr
                            class="border-gray-300 border-1 w-full rounded-md"
                          />
                          <label
                            class="block font-medium text-sm cursor-pointer text-primary-500 w-full"
                            ><span
                              class="font-medium text-base text-primary-800 dark:text-primary-200"
                              >Choisir les services</span
                            >
                          </label>
                          <hr
                            class="border-gray-300 border-1 w-full rounded-md"
                          />
                        </div>
                        <div class="bg-ww">
                          <h2 class="text-sm font-bold truncate mb-5">
                            Définir les services pour le nouveau warehouse de ce
                            seller
                          </h2>
                          <div class="flex flex-col lg:flex-row">
                            <div
                              id="confirmation"
                              @click="activate('confirmation')"
                              :class="{
                                active: expeditionData.setting.confirmation,
                              }"
                              class="border border-gray-600 intro-y flex-1 box-1 py-10 cursor-pointer zoom-in"
                            >
                              <div class="check">
                                <span class="feather-icon select-none relative" ><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow" > <polyline points="20 6 9 17 4 12" ></polyline></svg ></span>
                              </div>
                              <img
                                class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                                src="https://img.icons8.com/external-outline-lafs/64/000000/external-ic_support-menu-outline-lafs.png"
                              />
                              <div
                                class="text-xl font-medium text-center mt-10"
                              >
                                Confirmation
                              </div>
                            </div>
                            <div
                              id="fulfillement"
                              @click="activate('fulfillement')"
                              :class="{
                                active: expeditionData.setting.fulfillement,
                              }"
                              class="border border-gray-600 intro-y flex-1 box-1 py-10 lg:ml-5 mb-5 lg:mb-0 cursor-pointer zoom-in"
                            >
                              <div class="check">
                                <span class="feather-icon select-none relative" ><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow" > <polyline points="20 6 9 17 4 12" ></polyline></svg ></span>
                              </div>
                              <img
                                class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                                src="https://img.icons8.com/external-becris-lineal-becris/64/000000/external-warehouse-business-intelligence-becris-lineal-becris.png"
                              />
                              <div
                                class="text-xl font-medium text-center mt-10"
                              >
                                Warehouse
                              </div>
                              <!-- <div class="text-gray-600 dark:text-gray-400 px-10 text-center mx-auto mt-2"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. </div>
                                          <div class="flex justify-center"><div class="relative text-5xl font-semibold mt-8 mx-auto"><span class="absolute text-2xl top-0 left-0 text-gray-600 -ml-4">$</span> 120 </div></div>-->
                            </div>
                            <div
                              id="shipping"
                              @click="activate('shipping')"
                              :class="{
                                active: expeditionData.setting.shipping,
                              }"
                              class="border border-gray-600 intro-y flex-1 box-1 py-10 lg:ml-5 cursor-pointer zoom-in"
                            >
                              <div class="check">
                                <span class="feather-icon select-none relative" ><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow" > <polyline points="20 6 9 17 4 12" ></polyline></svg ></span>
                              </div>
                              <img
                                class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto"
                                src="https://img.icons8.com/external-bartama-glyph-64-bartama-graphic/64/000000/external-Shipping-e-commerce-glyph-bartama-glyph-64-bartama-graphic.png"
                              />
                              <div
                                class="text-xl font-medium text-center mt-10"
                              >
                                Shipping
                              </div>
                              <!-- <div class="text-gray-600 dark:text-gray-400 px-10 text-center mx-auto mt-2"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. </div>
                                          <div class="flex justify-center"><div class="relative text-5xl font-semibold mt-8 mx-auto"><span class="absolute text-2xl top-0 left-0 text-gray-600 -ml-4">$</span> 120 </div></div>-->
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div class="p-4 flex space-x-4">
                    <a
                      href="#"
                      @click="$vm2.close('ModalChangeSetSettingsSeller')"
                      class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400 font-bold rounded-lg text-sm"
                      >Cancel</a
                    >
                    <button
                      @click="confirmChangeExpedition"
                      class="w-1/2 px-4 py-3 text-center text-orange-100 bg-orange-600 rounded-lg hover:bg-orange-700 hover:text-white font-bold text-sm relative loidingconfirm"
                      :disabled="expeditionData.loading"
                    >
                      <loading
                        :active.sync="expeditionData.loading"
                        :is-full-page="fullPage"
                      ></loading
                      >Confirm
                    </button>
                  </div>
                </div>
              </div>
            </vue-modal-2>
            <!-- End Modal Change Set Settings Seller -->

            <!--  -->
            <vue-modal-2 name="showVariantModal" :headerOptions="{ title: 'Edit Variants Quantity' }" :noFooter="true" modalSize="sm" @on-close="$vm2.close('showVariantModal')">
              <!--  -->
              <div class="bg-white rounded-lg">
                <!--  -->
                <div class="relative" v-if="productId != -1">
                  <!--  -->
                  <div class="rounded-lg flex px-4 mt-3">
                    <div class="w-full change-status border hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="settings" class="bg-white text-gray-700 px-1" >Quantity</label>
                          </p>
                        </div>
                        <p>
                          <input type="number"  v-model="selectedQuantity" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                        </p>
                      </div>
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="p-4 flex space-x-4 mt-2">
                    <!--  -->
                    <a href="#" @click="$vm2.close('showVariantModal')"  class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400 font-bold rounded-lg text-sm">Cancel</a>
                    <!--  -->
                    <button @click="editAllVariants()" class="w-1/2 px-4 py-3 text-center text-orange-100 bg-orange-600 rounded-lg hover:bg-orange-700 hover:text-white font-bold text-sm relative loidingconfirm">
                      Confirm
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
            </vue-modal-2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import button from '../../components/~/button.vue';
export default {
  components: { button },
  data() {
    return {
      formData: {
        numberOfPackages: 1,
        weight: 0,
        date: this.$moment(new Date()).format('yyyy-MM-DDTHH:mm'),
        arrivalDate: null,
        carrier: {
          name: '',
          phone: '',
        },
        details: [],
        status: 'expedited',
        country: '',
        seller: '',
        quantity: {
          sent: 0,
        },
        transportMode: '',
      },
      currentUser: {
        role: {},
      },
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      searchText: '',
      oldstatus: '',
      products: [],
      warehouses: [],
      show_modal: true,
      productselected: [],
      numberItemRepeated: 0,
      sellers: [],
      status: ['expedited', 'received', 'cancelled'],
      transports: ['road', 'railway', 'air', 'maritime'],
      options: this.$countries,
      sellerExists: false,
      selectFromContry: '',
      selectToContry: '',
      wharhouse: null,
      loading: false,
      fullPage: false,
      CheckExpeditionRecived: false,
      expeditionData: {
        model: null,
        dataWhrahouseSetting: {},
        loading: false,
        data: {},
        country: null,
        warhouseParent: { exist: false, warehouse: null },
        setting: {
          exist: false,
          confirmation: false,
          fulfillement: false,
          shipping: false,
          warehouse: null,
        },
      },
      checkSetting: null,
      checkWarehousingParent: [],
      selectedQuantity: 0,
      productId: -1,
    };
  },
  async mounted() {
    this.loading = true;
    await this.getCurrentSeller();
    await this.getUser();

    //await this.getStatus();
    await this.dataToEdit();
    await this.getWarehouses();
    this.dateMin();
    this.loading = false;
    if (this.currentUser.type === 'Seller') {
      this.formData.country = this.currentUser.address;
    }
  },
  watch: {
        'formData.details': {
            handler: function(newValue) {
                var vm = this;
                vm.setValue();
            },
            deep: true
        },
        currentUser: {
          handler(newVal, oldVal) {
            this.formData.country = newVal.address;
          },
          deep: true,
        },
  },
  computed: {
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter(product => {
          var regex = new RegExp(this.searchText, 'i');

          return regex.test(product.name);
        });
      } else {
        return this.products;
      }
    },
  },
  methods: {
    openVariantModal(id) {
      this.productId = id;
      this.$vm2.open('showVariantModal');
    },
    editAllVariants() {
      const product = this.formData.details.find(item => item._id === this.productId);
      if (product && product.variantes) {
        product.variantes.forEach(variant => {
          variant.quantity.sent = this.selectedQuantity;
        });
      }
      this.$vm2.close('showVariantModal');
      this.productId= -1;
    },
    setValue: function() {
        for(var i = 0; i < this.formData.details.length; i++) {
            if(this.formData.details[i].variantes && this.formData.details[i].variantes.length>0)  this.formData.details[i].quantity.sent= this.formData.details[i].variantes.map(it => ( parseInt(it.quantity.sent)||0 ) ).reduce((prev, next) => prev + next);
            if(this.formData.details[i].quantity.sent) this.formData.details[i].quantity.sent = parseInt(this.formData.details[i].quantity.sent.toString().trim().replace('.', ''));
        }
    },
    isEmpty(value) {
        return (value == null || (typeof value === "string" && value.trim().length === 0));
    },
    isNumber (val) {
        if (isNaN(Number(val.key)) || this.isEmpty(val.key)) { 
          console.log('in nanisNumber-----',val.key)
          return val.preventDefault();
        }
    },
    async CheckQteSentExist(item) {
      this.CheckExpeditionRecived = false;
      if (item.status == 'received') {
        for (let i in item.details) {
          const filters = {
            product: item.details[i].product._id,
            expedition: item._id,
          };
          const res = await this.$server.search('stockHistories', filters);
          if (typeof res.content.results !== 'undefined') {
            this.CheckExpeditionRecived = true;
          }
        }
      }
    },
    activate: function(el) {
      this.expeditionData.setting[el] = !this.expeditionData.setting[el];
    },
    activateWarehouse: function(el) {
      
      this.checkWarehousingParent.forEach(function(warehouse) {
        if (warehouse._id.toString() == el._id.toString())
          warehouse.fullOf = true;
        else warehouse.fullOf = false;
      });
      this.expeditionData.warhouseParent.warehouse = el;
      
    },
    async confirmChangeExpedition() {
      if (
        this.expeditionData.setting.exist &&
        !this.expeditionData.setting.confirmation &&
        !this.expeditionData.setting.fulfillement &&
        !this.expeditionData.setting.shipping
      ) {
        alert('Les services est obligatoir', 'warning');
        return false;
      }
      if (this.expeditionData.warhouseParent.exist) {
        //check warehouse if select
        for (
          let index = 0;
          index < this.expeditionData.data.details.length;
          index++
        ) {
          const expeditionLine = this.expeditionData.data.details[index];
          if (!expeditionLine.warehouseParent) {
            alert(
              `Warehouse est obligatoir pour ce produit : ${expeditionLine.product.name}`,
              'warning',
            );
            return false;
            break;
          } else
            expeditionLine.warehouseParentName =
              expeditionLine.warehouseParent.name ||
              expeditionLine.warehouseParent;
        }
      }
      this.loading = true;
      const data = await this.$server.update(
        'expeditions',
        this.expeditionData,
      );
      this.loading = false;
      if (data && data._id) {
        this.checkSetting = null;
        (this.expeditionData.setting = {
          exist: false,
          confirmation: false,
          fulfillement: false,
          shipping: false,
          warehouse: null,
        }),
          (this.expeditionData.warhouseParent = {
            exist: false,
            warehouse: null,
          }),
          this.$vm2.close('ModalChangeSetSettingsSeller');
        this.formData.country = this.$f.getCountryNameByCode(
          this.options,
          this.selectFromContry,
        );
        this.formData.country_to = this.$f.getCountryNameByCode(
          this.options,
          this.selectToContry,
        );
        alert(this.$t('expedition_updated'), 'success');
        await this.dataToEdit();
      } else alert(data, 'warning');
    },
    async saveProductPrice(product) {
      if (product._id) {
        
        const resProductW = this.getElementInArray(
          product.details,
          this.wharhouse._id,
        );
        if (!resProductW)
          product.details.push({ price: 0, warehouse: this.wharhouse._id });
        
        await this.changePrice(
          product.details,
          this.wharhouse._id,
          product.newPrice,
        );
        
        this.loading = true;
        const data = await this.$server.update('products', product);
        this.loading = false;
        if (data._id) {
          product.price = parseInt(product.newPrice);
          alert(this.$t('product_updated'), 'success');
        }
      }
    },
    async changePrice(data, value, price) {
      for (var i in data) {
        if (data[i].warehouse == value.toString()) {
          data[i].price = price;
          break; //Stop this loop, we found it!
        }
      }
    },
    async getwharhouse(country) {
      const resW = await this.$server.get('warehouses', {
        country: country,
        is_primary: true,
      });
      if (resW.content) return resW.content;
    },
    searchSellers: _.debounce(async function(search, event) {
      if (this.selectToContry) {
        const filter = {
          type: 'Seller',
          limit: this.limit,
          countries: this.selectToContry,
          name: search,
        };
        const res = await this.$server.find('users', filter);

        if (res && res.content.results) this.sellers = res.content.results;
        else this.sellers = [];
      } else alert('Please select a country !', 'warning');
    }, 500),
    dateMin() {
      // document.getElementById('dateexp').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD'));
      // if(this.currentUser.type != "Seller")  document.getElementById('dateexpar').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD'));
    },
    exceptDes(text) {
      if (text && text.length > 60) text = text.substring(0, 60) + '...';
      return text;
    },
    setSelectedFromContry(contry) {
      if (contry) {
        this.formData.country = contry.name;
        this.selectFromContry = contry.code;
      }
    },
    async setSelectedToContry(contry) {
      if (contry) {
        this.formData.country_to = contry.name;
        this.selectToContry = contry.code;
        this.products = [];
        if(this.currentUser.type != "CEO"){
          this.formData.details = [];
        }
        this.wharhouse = await this.getwharhouse(contry.code);
        await this.getSellers(contry.code);
      }
    },
    setStatusSelected(status) {
      if (status) {
        this.formData.status = status;
      } else {
        this.formData.status = '';
      }
    },
    async getCurrentSeller() {
      const res = await this.$server.me('users');
      if (res.content) {
        const currentUser = res.content;
        if (currentUser.type == 'Seller')
          this.formData.seller = currentUser._id;
      }
    },
    async getSellers(country) {
      if (this.currentUser.type != 'Seller') {
        const res = await this.$server.search('users', {
          type: 'Seller',
          countries: country,
        });
        if (res.content.results) {
          this.sellers = res.content.results;
          this.sellerExists = true;
        }
      }
    },
    async getUser() {
      const res = await this.$server.me('users');
      
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async getProducts(filters) {
      const resW = await this.$server.get('warehouses', {
        country: this.selectToContry,
      });
      if (this.formData.seller) {
        filters.seller = this.formData.seller._id;
        filters.limit = 2000;

        const res = await this.$server.search('products', filters);
        if (res.content.results) {
          this.products = res.content.results;
          this.paginate.total = res.content.total;
          this.paginate.lastpage = res.content.last_page;
          this.paginate.per_page = res.content.per_page;
          this.paginate.currentpage = res.content.current_page;

          for (let i in this.products) {
            if (this.products[i].seller)
              this.products[i].seller = this.products[i].seller._id;
            const resProductW = this.getElementInArray(
              this.products[i].details,
              resW.content._id,
            );
            if (resProductW) this.products[i].price = resProductW.price || 0;
            else this.products[i].price = 0;
            this.products[i].newPrice = 0;
          }
        } else this.products = [];
      }
    },
    getElementInArray(data, value) {
      
      
      var result = data.filter(function(o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null; // or undefined
    },
    async save() {
      if (this.formData._id) {
        //this.formData.country = this.selectFromContry;
        this.formData.country_to = this.selectToContry;
        this.loading = true;
        //check warhouse parent
        const resW = await this.$server.search('warehouses', {
          country: this.selectToContry,
          limit: 100,
        });
        
        if (resW.content && resW.content.results) {
          this.checkWarehousingParent = resW.content.results.sort((a, b) =>
            a._id > b._id ? 1 : b._id > a._id ? -1 : 0,
          );
          this.checkWarehousingParent.forEach(x => {
            x.fullOf = false;
          });
        } else this.checkWarehousingParent = [];

        //check user services
        
        this.checkSetting = this.getElementInArray(
          this.formData.seller.settings,
          this.wharhouse._id || this.wharhouse,
        );
        
        if (
          this.formData.status == 'received' &&
          (this.checkWarehousingParent.length > 1 ||
            !this.checkSetting ||
            (this.checkSetting &&
              !this.checkSetting.confirmation &&
              !this.checkSetting.fulfillement &&
              !this.checkSetting.shipping))
        ) {
          if (
            !this.checkSetting ||
            (this.checkSetting &&
              !this.checkSetting.confirmation &&
              !this.checkSetting.fulfillement &&
              !this.checkSetting.shipping)
          )
            this.expeditionData.setting.exist = true;
          if (this.checkWarehousingParent.length > 1)
            this.expeditionData.warhouseParent.exist = true;
          this.expeditionData.country = this.$f.getCountryNameByCode(
            this.options,
            this.formData.country_to,
          );
          this.expeditionData.data = this.formData;
          this.$vm2.open('ModalChangeSetSettingsSeller');
          this.loading = false;
          
          return false;
        }

        // return false;
        this.formData.seller = this.formData.seller._id;
        const data = await this.$server.update('expeditions', this.formData);
        this.loading = false;
        if (data && data._id) {
          this.formData.country = this.$f.getCountryNameByCode(
            this.options,
            this.selectFromContry,
          );
          this.formData.country_to = this.$f.getCountryNameByCode(
            this.options,
            this.selectToContry,
          );
          alert(this.$t('expedition_updated'), 'success');
          await this.dataToEdit();
        } else alert(data, 'warning');
      } else {
        if (this.checkData()) {
          this.loading = true;
          for (let i in this.formData.details) {
            if (
              !this.formData.details[i].merchandise_value ||
              parseInt(this.formData.details[i].merchandise_value) == 0
            ) {
              alert(this.$t('commodity_value_required'), 'warning');
              this.loading = false;
              return false;
              break;
            }
          }

          // this.formData.country = this.selectFromContry;
          this.formData.country_to = this.selectToContry;
          const data = await this.$server.create('expeditions', this.formData);
          this.loading = false;
          if (data && data._id) {
            this.selectFromContry = this.selectToContry = '';
            this.formData = {
              carrier: {},
              details: [],
            };
            if (this.currentUser.type == 'Seller') {
              this.formData.seller = this.currentUser._id;
            }
            alert(this.$t('expedition_created'), 'success');
          } else alert(data, 'warning');
        } else {
          alert(this.$t('all_required_field'), 'warning');
        }
      }
    },
    async getWarehouses() {
      const filter = { limit: 1000, is_primary: true };
      const res = await this.$server.search('warehouses', filter);
      if (res.content.results) {
        let data = res.content.results;
        for (let i in data) {
          this.warehouses.push({
            name: this.$f.getCountryNameByCode(this.options, data[i].country),
            code: data[i].country,
          });
        }
        const warehouse = this.warehouses.find(warehouse => { return warehouse.code === "MA"})
        if (warehouse) {
          this.formData.country_to = warehouse.name;
          await this.setSelectedToContry(warehouse);
        }
      } else this.warehouses = [];
    },
    getQuantity() {
      this.formData.quantity.sent = 0;
      for (let i = 0; i < this.formData.details.length; i++) {
        this.formData.quantity.sent += this.formData.details[i].quantity;
      }
    },
    checkData() {
      if (
        this.formData.numberOfPackages &&
        this.formData.country &&
        this.formData.country_to &&
        this.formData.date &&
        this.formData.closeTime &&
        this.formData.details.length > 0 &&
        this.formData.seller
      )
        return true;
      else return false;
    },
    removeProduct(data, index) {
      this.$confirm('Are you sure you want to delete this product?').then(
        async res => {
          let pos = this.formData.details
            .map(function(e) {
              return e.product._id;
            })
            .indexOf(data._id);

          this.formData.details.splice(pos, 1);
          data.product.check = false;
          alert(this.$t('product_deleted'), 'success');
        },
      );
    },
    addProductsToTemp(data, index) {
      if (data.check) {
        var detail = { product: data, quantity: {sent: 1}};

        let found = 0;
        for (let i = 0; i < this.formData.details.length; i++) {
          if (this.formData.details[i].product._id == data._id) {
            found = found + 1;
            this.numberItemRepeated = this.numberItemRepeated + 1;
          }
        }
        if (found >= 1) {
        } else {
          const dataVra=data.details.find( item => item.warehouse && item.warehouse.country === this.selectToContry);
          if(dataVra && dataVra.variantes && dataVra.variantes.length>0) detail.variantes=dataVra.variantes.map(el => ({id: el.id,name: el.name,quantity: {sent:0}}));
          this.productselected.push(detail);
        }
      } else {
        let pos = this.productselected
          .map(function(e) {
            return e.product._id;
          })
          .indexOf(data._id);
        this.productselected.splice(pos, 1);
      }
    },
    addQuantity(index) {
      this.formData.details[index].quantity.sent++;
    },
    removeQuantity(index) {
      if (this.formData.details[index].quantity.sent <= 1) {
      } else {
        this.formData.details[index].quantity.sent--;
      }
    },
    ViderTable() {
      this.productselected = [];
    },
    ViderProductTable() {
      this.formData.details = [];
    },
    async OpenPopUp() {
      if (!this.formData.country_to) {
        alert(this.$t('select_country'), 'warning');
        return false;
      }
      if (this.formData.seller) {
        await this.getProducts({});
        if (this.products.length > 0) {
          this.$vm2.open('Modal_products');
        } else {
          if (this.currentUser.type != 'Seller')
            alert(this.$t('no_products_seller'), 'warning');
          else alert(this.$t('no_product_added'), 'warning');
        }
      } else {
        alert(this.$t('must_select_seller'), 'warning');
      }
    },
    ConfirmOperation() {
      let fount = 0;
      if (this.numberItemRepeated > 0) {
        alert(this.$t('product_already_added'), 'success');
      } else {
        for (let i = 0; i < this.productselected.length; i++) {
          this.formData.details.push(this.productselected[i]);
        }
      }
      this.productselected = [];

      this.numberItemRepeated = 0;
      this.$vm2.close('Modal_products');
    },
    closePopUp() {
      this.$vm2.close('Modal_products');
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get('expeditions', {
          id: this.$route.params.id,
        });
        this.formData = editData.content;
        this.oldstatus = this.formData.status;
        this.wharhouse = await this.getwharhouse(this.formData.country_to);
        await this.CheckQteSentExist(this.formData);
        this.selectFromContry = this.formData.country;

        this.selectToContry = this.formData.country_to;
        this.formData.country_to = this.$f.getCountryNameByCode(
          this.options,
          this.formData.country_to,
        );
        this.formData.date = this.$moment(this.formData.date).format(
          'yyyy-MM-DDTHH:mm',
        );
        if (this.formData.arrivalDate)
          this.formData.arrivalDate = this.$moment(
            this.formData.arrivalDate,
          ).format('yyyy-MM-DDTHH:mm');
        await this.getSellers(this.formData.country_to);
      }
    },
  },
};
</script>

<style>
.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}
.left-3 {
  left: 0.75rem;
}
.top-2 {
  top: 0.1rem;
}
.vs__dropdown-toggle {
  border: none;
}
.modal-header {
  background: #226faa;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#226faa),
    color-stop(37%, #2989d8),
    to(#72c0d3)
  );
  background: linear-gradient(to right, #226faa 0, #2989d8 37%, #72c0d3 100%);
  border-radius: 6px;
  color: #fff;
  padding: 18px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-color: transparent;
  border-bottom: 1px solid #e5e5e5;
}

.table.item thead {
  background: #3182ce4f;
  color: #fff;
  border: 0;
}

.toggle__dot {
  transition: all 0.3s ease-in-out;
}

.seller-select .vs__dropdown-toggle {
  border: none;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #68d391;
}

/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.btn-bottom-toolbar {
  position: fixed;
  bottom: 0;
  padding: 12px;
  padding-right: 70px;
  margin: 0px 0 0 -40px;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  background: #fff;
  width: calc(100% - 211px);
  z-index: 60;
  border-top: 1px solid #ededed;
}
.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
</style>
